'use strict';

const BaseModel = require('./baseModel');

class CompanyModel extends BaseModel {
  constructor() {
    super(companySchema);
  }

  static getSchema() {
    return companySchema;
  }
}

const companySchema = {
  name: {
    required: {
      message: 'This field is required.'
    },
    isLength: {
      options: {min: 1, max: 255},
      message: 'Max length 255 characters and Min 1 characters'
    }
  },
  address: {},
  city: {
    required: {
      message: 'This field is required.'
    }
  },
  state: {
    required: {
      message: 'This field is required.'
    }
  },
  website: {},
  zip:{
    isNumeric: {
      message: 'Must be numeric'
    }
  },
  numberOfOffices: {
    isNumeric: {
      message: 'Must be numeric'
    }
  },
  numberOfEmployees: {
    required: {
      message: 'This field is required.'
    },
    isNumeric: {
      message: 'Must be numeric'
    }
  },
  parentCompany: {},
  phoneNumber: {
    isLength: {
      options: {min: 10, max: 10},
      message: 'Must be 10 digits'
    },
    isNumeric: {
      message: 'Must be numeric'
    },
    matches: {
      options: /^[2-9]\d{9}$/,
      message: 'Must be a valid phone number.'
    }
  },
  parentCompanyId: {},
  segmentTypes: {
    required: {
      message: 'This field is required.'
    }
  },
  industryTypes: {
    required: {
      message: 'This field is required.'
    }
  },
  segmentOther: {},
  industryOther: {},
  tradeAssociations:{},
  iiabaState: {},
  salesPartner: {},
  inquiryHelp: {
    required: {
      message: 'This field is required.'
    }
  },
  affiliationTypes:{
  },
  affiliationOther: {},
  networkAffiliationsYesNo:{
  },
  networkAffiliations:{
  }

};

module.exports = CompanyModel;



// WEBPACK FOOTER //
// ./shared/models/company.js